import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

// Styled components.
import theme from 'styles/theme';
import styles from './styles';

/**
 * A component representing a label.
 */
export default class SearchFilterLabel extends React.PureComponent {
  /**
   * Define PropTypes for this component.
   * @type {object}
   */
  static propTypes = {
    text: PropTypes.string,
    handleClearFilter: PropTypes.func,
  };

  /**
   * Define default props for this component.
   * @type {object}
   */
  static defaultProps = {
    text: '',
    handleClearFilter: () => {},
  };

  render() {
    const { Wrapper } = styles;
    const { text, handleClearFilter } = this.props;

    return (
      <ThemeProvider theme={theme}>
        <Wrapper>
          <div className="election-hub__search-filter-label">
            <span className="election-hub__search-filter-label--text">
              {text}
            </span>
            <span
              className="election-hub__search-filter-label--remove-button"
              onClick={handleClearFilter}
              onKeyDown={handleClearFilter}
              role="button"
              tabIndex={0}
            >
              &#x2715;
            </span>
          </div>
        </Wrapper>
      </ThemeProvider>
    );
  }
}
